import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label, Input, Button, Col, Row, Alert } from 'reactstrap';

import {
  fetchDatabases,
  fetchMappings,
  fetchSourceTables,
  fetchTargetTables,
  filterByOverride,
  loadMappedData,
  clearSourceMessage
} from '../../../../actions/synchronisationActions';
import { getOne } from '../../../../actions/storeActions';
import MappingTable from './containers/MappingTable';
import MappingAuditModal from './containers/MappingAuditModal';
import SourceSelector from '../../containers/SourceSelector';

class SyncMapping extends React.Component {
  state = { auditOpen: false };

  toggleAudit = () => this.setState(s => ({ auditOpen: !s.auditOpen }));

  async componentDidMount() {
    const { currentStore, fetchStore, clearSourceMessage } = this.props;
    // Drop any message carried over from another tab's action (e.g. the exclusion save on Activity
    // auto-sends mappings, which sets a "Successfully sent mappings" message the user didn't trigger here).
    clearSourceMessage();
    if (currentStore.storeId) {
      fetchStore(currentStore.id);
      this.fetchAll();
    }
  }

  componentDidUpdate(prevProps) {
    const { currentStore, sourceId } = this.props;
    if (prevProps.currentStore.storeId !== currentStore.storeId || prevProps.sourceId !== sourceId) {
      this.fetchAll();
    }
  }

  fetchAll() {
    const { currentStore, sourceId, fetchMappings, fetchSourceTables, fetchTargetTables } = this.props;
    fetchMappings(currentStore.storeId, sourceId);
    fetchSourceTables(currentStore.storeId, false, sourceId);
    fetchTargetTables(currentStore.storeId);
  }

  handleOverrideOnly = event => {
    const { filterByOverride } = this.props;
    filterByOverride(event.target.checked);
  };

  handleSendMappings = () => {
    const { currentStore, sourceId, sendMappings } = this.props;
    sendMappings(currentStore.storeId, sourceId);
  };

  onDismiss = () => {
    this.props.clearSourceMessage();
  };

  render() {
    const { currentStore, message, isError } = this.props;

    return (
      <div className="mt-4">
        <SourceSelector />
        {message && (
          <Alert color={isError ? 'danger' : 'success'} isOpen={!!message} toggle={this.onDismiss}>
            {message}
          </Alert>
        )}

        <Row>
          <Col xs={6}>
            <FormGroup check>
              <Label check>
                <Input type="checkbox" onChange={this.handleOverrideOnly} />
                <span className="ms-2">Show overrides only</span>
              </Label>
            </FormGroup>
          </Col>
          <Col xs={6} className="d-flex flex-row justify-content-end align-items-center">
            <Button color="link" className="me-3" onClick={this.toggleAudit}>
              View change history
            </Button>
            <Button color="light" onClick={this.handleSendMappings}>
              Send Mappings
            </Button>
          </Col>
        </Row>

        <MappingTable storeId={currentStore && currentStore.storeId} sourceId={this.props.sourceId} />

        <MappingAuditModal
          isOpen={this.state.auditOpen}
          toggle={this.toggleAudit}
          storeId={currentStore && currentStore.storeId}
          sourceId={this.props.sourceId}
        />
      </div>
    );
  }
}

export default connect(
  state => {
    return {
      currentStore: state.store.one,
      dataCentre: state.dataCentre,
      sources: state.sync.source.sources,
      sourceId: state.sync.source.currentSourceId,
      message: state.sync.mapping.message,
      isError: state.sync.mapping.isError
    };
  },
  dispatch => ({
    fetchStore: storeId => dispatch(getOne(storeId)),
    fetchDatabases: (storeId, protocol, hostName, port) => dispatch(fetchDatabases(storeId, protocol, hostName, port)),
    fetchMappings: (storeId, sourceId) => dispatch(fetchMappings(storeId, sourceId)),
    fetchSourceTables: (storeId, mappedOnly, sourceId) => dispatch(fetchSourceTables(storeId, mappedOnly, sourceId)),
    fetchTargetTables: storeId => dispatch(fetchTargetTables(storeId)),
    filterByOverride: override => dispatch(filterByOverride(override)),
    sendMappings: (storeId, sourceId) => dispatch(loadMappedData(storeId, sourceId)),
    clearSourceMessage: () => dispatch(clearSourceMessage())
  })
)(SyncMapping);
